import type { FC } from 'react';
import { observer } from 'mobx-react-lite';
import useCurrentTasksFormStore from '../../hooks/useCurrentTasksFormStore';
import type { OptionValue } from '../../../../types/shared';
import type { ConditionVariantProps } from '../../types';
import { RuleEditAutoCompleteStyled } from '../RuleEditComponents';
import { useCallback } from 'react';
import { useMetricLevelConstraints } from '../../hooks';

export const LevelsMetrics: FC<ConditionVariantProps> = observer(
  ({ indexCondition, indexTask, field, indexVariant }) => {
    const tasksFormStore = useCurrentTasksFormStore();
    const handleChangeLevel = useCallback(
      (value: OptionValue) => {
        tasksFormStore.setConditionMetric(indexTask, indexCondition, field, value as string);
      },
      [field, indexCondition, indexTask, tasksFormStore]
    );

    const { disabled, options, isVariant } = useMetricLevelConstraints({
      indexCondition,
      indexTask,
      field,
      indexVariant,
    });

    const value = isVariant
      ? tasksFormStore.getVariantOnTaskCondition(indexTask, Number(indexVariant), indexCondition)?.[field]
      : tasksFormStore.getConditionMetric(indexTask, indexCondition)?.[field];

    return (
      <RuleEditAutoCompleteStyled
        allSelectable={false}
        value={value}
        onChange={handleChangeLevel}
        id={`Autocomplete-${field}-${indexTask}-${indexCondition}`}
        options={options}
        InputProps={{
          ...(tasksFormStore?.propsRestriction ?? null),
          disabled: disabled,
        }}
      />
    );
  }
);

export default LevelsMetrics;
